module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_6_1.b2306ebb.png";